<ion-buttons style="justify-content: flex-end;">
  <ion-button id="closeButton" (click)="onCloseDialog()">
    <ion-icon name="close-circle-outline" size="large"></ion-icon>
  </ion-button>
</ion-buttons>

<div class="dialog-content">
  <h3>
    {{ "PROFILE.REQUEST_DELETE_ACCOUNT" | translate }}
  </h3>
  <p>
    {{ "PROFILE.REQUEST_DELETE_ACCOUNT_TEXT" | translate }}
  </p>

  <ion-item>
    <ion-select
      [(ngModel)]="usePseudonymized"
      [value]="-1"
      id="inputDeletionType"
      okText='{{ "BUTTONS.SAVE" | translate }}'
      cancelText='{{ "BUTTONS.CANCEL" | translate }}'
      label='{{ "PROFILE.REQUEST_DELETE_ACCOUNT_DATA" | translate }}'
    >
      <ion-select-option [value]="true" id="inputDeletionTypePseudo">
        {{ "PROFILE.REQUEST_DELETE_ACCOUNT_PSEUDONYMIZE" | translate }}
      </ion-select-option>
      <ion-select-option [value]="false" id="inputDeletionTypeDelete">
        {{ "PROFILE.REQUEST_DELETE_ACCOUNT_DELETE_DATA" | translate }}
      </ion-select-option>
    </ion-select>
  </ion-item>

  <ion-item class="item" lines="none">
    <ion-input
      type="password"
      [(ngModel)]="password"
      name="password"
      label="{{ 'LOGIN_REGISTRATION.PASSWORD' | translate }}"
      labelPlacement="floating"
      errorText="{{ 'ERROR.ERROR_LOGIN_ENTER_PASSWORD' | translate }}"
      class="font"
      id="inputPWDeletion"
      required
    >
      <!-- TODO:
       The ion-input-password-toggle cannot be used directly, since there is a bug that hinders the floating animation of the label
       if the eye button is visible.
       To temporarily work around the floating animation bug, the password toggle button is only displayed when the text field
       contains characters.
       Keep track on this issue on GitHub: https://github.com/ionic-team/ionic-framework/issues/28665
       If the issue is closed and you have updated Ionic to the newest version, you may can remove the @if Angular block and use the
       ion-input-password-toggle directly!
       Please also don't forget to remove the @if control flow here:
        - Patientenmodul/src/app/pages/login/login.page.html
        - Patientenmodul/src/app/pages/settings/settings.page.html
       -->
      @if (password) {
        <ion-input-password-toggle slot="end"></ion-input-password-toggle>
      }
    </ion-input>
  </ion-item>
</div>

<ion-buttons class="dialog-actions">
  <ion-button
    class="dialog-action"
    color="primary"
    fill="solid"
    [disabled]="password == '' || (usePseudonymized != false && usePseudonymized != true)"
    id="requestDeletionButton"
    (click)="requestDeletion()"
  >
    {{ "PROFILE.REQUEST_DELETE_ACCOUNT_BUTTON" | translate }}
  </ion-button>
</ion-buttons>
